import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const MotorcycleRepair = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my motorcycle repair business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps motorcycle repair businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for motorcycle repair businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most motorcycle repair businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my motorcycle repair business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like motorcycle repair. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Motorcycle Repair - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Motorcycle Repair CRM", url: "/industries/motorcycle-repair" }
  ];

  const industryData = {
    name: 'Motorcycle Repair',
    title: 'Capture Riding Season Rush & Build Loyal Rider Community',
    subtitle: 'Automate spring service bookings, capture emergency repairs, and build year-round maintenance revenue',
    icon: '🏍️',
    challenges: [
      'Overwhelmed when riding season starts',
      'Riders forget winterization',
      'Emergency breakdowns interrupt schedule',
      'Hard to schedule custom builds',
      'Parts availability causes delays'
    ],
    solutions: [
      'Pre-season service automation',
      'Winter storage and prep reminders',
      'Emergency repair booking',
      'Custom build project management',
      'Parts ordering automation'
    ],
    features: [
      'Customer CRM with bike details',
      'Seasonal service reminders',
      'Emergency repair capture',
      'Custom build tracking',
      'Parts inventory system',
      'Ride event coordination',
      'Before/after galleries',
      'Review automation'
    ],
    results: [
      'Book 8+ weeks in advance',
      '95% spring service capture',
      '3x custom build projects',
      '£6.9K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Motorcycle Repair UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for motorcycle repair businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for motorcycle repair UK, motorcycle repair business software, motorcycle repair customer management, motorcycle repair lead generation UK"
        url="/industries/motorcycle-repair"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default MotorcycleRepair;